<template>
  <div id="popup-receive" class="py-5 px-10">
    <h4>รายละเอียดการรับอุปกรณ์</h4>
    <vs-divider position="center"></vs-divider>
    <!-- <form> -->
    <vs-row class="mt-5">
      <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
        <p>
          <b>ชื่อผู้ควบคุมเรือ / ไต๋เรือ / ผู้ทำการประมง : </b>
          {{ vesselInfo.ownerName }}
        </p>
      </vs-col>
      <vs-col class="mt-5" vs-w="12" vs-lg="6" vs-sm="12" vs-xs="12">
        <p><b>เลขบัตรประจำตัวประชาชน :</b> {{ vesselInfo.cardNumber }}</p>
      </vs-col>
      <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
        <p>ชื่อเรือ : {{ vesselInfo.name }}</p>
      </vs-col>
      <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
        <p>หมายเลขทะเบียนเรือ : {{ vesselInfo.registrationNumber }}</p>
      </vs-col>
      <vs-col class="mt-5" vs-w="12" vs-lg="4" vs-sm="12" vs-xs="12">
        <p>วัตถุประสงค์ในการใช้เรือ : {{ vesselInfo.objective }}</p>
      </vs-col>
    </vs-row>

    <vs-row class="mt-5 w-full">
      <vs-divider />
    </vs-row>

    <vs-row class="mb-5">
      <vs-col vs-type="flex" vs-justify="left" vs-lg="4" vs-sm="12" vs-xs="12">
        <h5 class="mt-5">อุปกรณ์ที่รับ</h5>
      </vs-col>
    </vs-row>

    <vs-row class="mt-5">
      <vs-col class="mb-5" vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-checkbox class="ml-20" v-model="checkbox.ais" disabled
          ><p class="pl-3">อุปกรณ์ AIS Transponder</p></vs-checkbox
        >
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          type="number"
          min="1"
          class="w-4/5"
          label="จำนวน"
          v-model="aisAmount"
        />
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          class="w-4/5"
          label="หมายเลขซีเรียล"
          v-model="aisSerialNumber"
          v-validate="checkbox.ais && 'required'"
          name="ais_serialnumber"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('ais_serialnumber')"
          >{{ errors.first("ais_serialnumber") }}</span
        >
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="mb-5" vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-checkbox class="ml-20" v-model="checkbox.vhf" disabled>
          <p class="pl-3">อุปกรณ์ VHF Antenna</p>
        </vs-checkbox>
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          type="number"
          min="1"
          class="w-4/5"
          label="จำนวน"
          v-model="vhfAmount"
        />
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          class="w-4/5"
          label="หมายเลขซีเรียล"
          v-model="vhfSerialNumber"
          v-validate="checkbox.vhf && 'required'"
          name="vhf_serialnumber"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('vhf_serialnumber')"
          >{{ errors.first("vhf_serialnumber") }}</span
        >
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="mb-5" vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-checkbox class="ml-20" v-model="checkbox.gps" disabled>
          <p class="pl-3">อุปกรณ์ GPS Antenna</p>
        </vs-checkbox>
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          type="number"
          min="1"
          class="w-4/5"
          label="จำนวน"
          v-model="gpsAmount"
        />
      </vs-col>
      <vs-col class="mb-5" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-input
          class="w-4/5"
          label="หมายเลขซีเรียล"
          v-model="gpsSerialNumber"
          v-validate="checkbox.gps && 'required'"
          name="gps_serialnumber"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('gps_serialnumber')"
          >{{ errors.first("gps_serialnumber") }}</span
        >
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="mb-0" vs-type="flex" vs-lg="4" vs-sm="12" vs-xs="12">
        <vs-checkbox class="ml-20 my-4" v-model="checkbox.other">
          <p class="pl-3">อุปกรณ์อื่นๆ โปรดระบุ</p>
        </vs-checkbox>
      </vs-col>
    </vs-row>
    <!-- other -->
    <vs-row
      v-show="checkbox.other"
      class="pl-10"
      v-for="(item, index) in otherTools"
      :key="index"
    >
      <vs-col class="mb-5 mt-8" vs-type="flex" vs-lg="1" vs-sm="12" vs-xs="12">
        <p class="ml-20">{{ index + 1 }}.</p>
      </vs-col>
      <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
        <vs-input
          class="w-full"
          label="ชื่ออุปกรณ์"
          v-model="otherTools[index].name"
          v-validate="checkbox.other && 'required'"
          :name="`other_name${index}`"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has(`other_name${index}`)"
          >{{ errors.first(`other_name${index}`) }}</span
        >
      </vs-col>
      <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
        <vs-input
          type="number"
          class="w-full"
          label="จำนวน"
          min="1"
          v-model="otherTools[index].amount"
        />
      </vs-col>
      <vs-col class="mb-5" vs-lg="3" vs-sm="12" vs-xs="12">
        <vs-input
          class="w-full"
          label="หมายเลขซีเรียล"
          v-model="otherTools[index].serialNumber"
          v-validate="checkbox.other && 'required'"
          :name="`other_serialnumber${index}`"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has(`other_serialnumber${index}`)"
          >{{ errors.first(`other_serialnumber${index}`) }}</span
        >
      </vs-col>
      <vs-col class="mb-5 mt-6" vs-lg="2" vs-sm="12" vs-xs="12">
        <vs-button
          v-if="index == otherTools.length - 1 && index != 2"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-plus"
          @click="addOtherTool()"
        ></vs-button>
        <vs-button
          v-else
          color="danger"
          type="border"
          icon-pack="feather"
          icon="icon-minus"
          @click="deleteOtherTool(index)"
        ></vs-button>
      </vs-col>
    </vs-row>
    <vs-row>
      <!-- document -->
      <div class="w-full mb-5 mt-10" align="center">
        <div v-if="documentFiles.length != 0" class="demo-alignment px-20 flex content-center justify-center">
          <div v-for="(item, index) in documentFiles" :key="index">
            <vs-chip @click="remove(index)" closable>
              <vs-avatar
                v-if="item.type == 'application/pdf'"
                icon-pack="feather"
                icon="icon-file"
                class="m-3"
                style="height: 30px; width: 30px"
              />
              <!-- <vs-avatar v-else :src="documentFilesURL[index]" align="center" class="h-24 min-h-full w-24 max-w-full" /> -->
              <img
                v-else
                :src="documentFilesURL[index]"
                class="m-3"
                style="height: 100px; max-width: 150px"
              />
              <span>{{ item.name }} </span>
            </vs-chip>
          </div>
        </div>
        <div v-else class="box" id="preview">
          <img
            src="../../../assets/icons/cloud-img.png"
            width="200"
            height="200"
          />
        </div>
        <div>
          <vs-button
            icon-pack="feather"
            icon="icon-upload"
            class="mt-10"
            color="primary"
            @click="$refs.onChangeFiles.click()"
          >
            <span class="d-none d-sm-block">อัปโหลดรูป</span>
          </vs-button>
          <input
            ref="onChangeFiles"
            type="file"
            accept=".jpeg,.png,.jpg,.GIF,.pdf"
            :hidden="true"
            @change="onChangeFiles"
            v-validate="'required'"
            name="files"
            multiple="multiple"
          />
          <span class="text-danger text-sm" v-show="errors.has('files')">{{
            errors.first("files")
          }}</span>
        </div>
        <h6 class="mt-5">อัปโหลดเอกสารการรับอุปกรณ์ติดตั้งเรือ</h6>
        <p class="mt-2" style="color: gray; font-size: 12px;">*อัปโหลดได้ไม่เกิน 5 ไฟล์</p>
      </div>
    </vs-row>

    <!-- <vs-row class="mt-20 mb-10">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p class="ml-10">
          ลงชื่อ...........................................................ผู้ยื่นคำขอ
        </p>
        <br />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p>(...........................................................)</p>
        <br />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p>วันที่.........../............/...........</p>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p class="ml-10">
          ลงชื่อ...........................................................(เจ้าหน้าที่)
        </p>
        <br />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p>(...........................................................)</p>
        <br />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <p>วันที่.........../............/...........</p>
      </vs-col>
    </vs-row> -->

    <div align="center" class="my-5">
      <vs-button
        type="filled"
        @click.prevent="submitForm"
        class="mt-5 mr-5"
        >ยืนยันการรับอุปกรณ์</vs-button
      >
      <vs-button color="danger" type="border" @click="()=> this.$emit('onClosedRecieve', false)">ย้อนกลับ</vs-button>
    </div>
    <!-- </form> -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Validator } from "vee-validate";
import { ACCESSORIES } from "../../../mock-data/form-validate.js";
// register custom messages
Validator.localize("en", ACCESSORIES);

export default {
  name: "ReparationAdd",
  props: {
    info: Object,
    dataVessel: Object,
    active: Boolean,
  },
  data() {
    return {
      vesselInfo: {},
      checkbox: {
        ais: true,
        vhf: true,
        gps: true,
        other: false,
      },
      isComfirm: false,
      aisAmount: 1,
      vhfAmount: 1,
      gpsAmount: 1,
      aisSerialNumber: null,
      vhfSerialNumber: null,
      gpsSerialNumber: null,
      otherTools: [
        {
          name: null,
          amount: 1,
          serialNumber: null,
        },
      ],
      documentFiles: [],
      documentFilesURL: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch:{

  },
  methods: {
    async getData(){
      await this.$store.dispatch(`vessels/setVesselById`, this.dataVessel.id );
      this.vesselInfo = this.$store.state.vessels.vessel.vessel;
      console.log("this.vesselInfo === ", this.vesselInfo);
    },
    submitForm() {
      if (
        !this.checkbox.ais &&
        !this.checkbox.vhf &&
        !this.checkbox.gps &&
        !this.checkbox.other
      ) {
        Swal.fire({
          target: document.getElementById("popup-receive"),
          icon: "error",
          title: "กรุณาเลือกรายการ",
          text: "เลือกอุปกรณ์ที่ต้องการทำรายการ",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            // if form have no errors
            Swal.fire({
              target: document.getElementById("popup-receive"),
              title: "ยืนยันการรับอุปกรณ์",
              text: "",
              icon: "question",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ยกเลิก",
              showCancelButton: true,
              preConfirm: () => {
                let accessories = [];
                if (this.checkbox.ais) {
                  accessories.push({
                    name: "AIS Transponder",
                    amount: this.aisAmount,
                    serialNumber: this.aisSerialNumber,
                    type: 1,
                  });
                }
                if (this.checkbox.vhf) {
                  accessories.push({
                    name: "VHF Antenna",
                    amount: this.vhfAmount,
                    serialNumber: this.vhfSerialNumber,
                    type: 2,
                  });
                }
                if (this.checkbox.gps) {
                  accessories.push({
                    name: "GPS Antenna",
                    amount: this.gpsAmount,
                    serialNumber: this.gpsSerialNumber,
                    type: 3,
                  });
                }
                if (this.checkbox.other) {
                  for (const otherTool of this.otherTools) {
                    accessories.push({
                      ...otherTool,
                      type: 4,
                    });
                  }
                }
                const data = {
                  registrationId: this.dataVessel.id,
                  type: 1,
                  accessories,
                };
                this.$store
                  .dispatch("accessories/createAccessories", {
                    data,
                    documents: this.documentFiles,
                  })
                  .then(() => {
                    const error = this.$store.state.accessories.error;
                    if (error) {
                      Swal.fire({
                        target: document.getElementById("popup-receive"),
                        icon: "error",
                        title: "ข้อมูลเกินจำนวนที่กำหนด",
                        text: "กรุณาอัปโหลดไฟล์ไม่เกิน 5 ไฟล์",
                        showConfirmButton: false,
                        timer: 2500,
                      });
                    } else {
                      Swal.fire({
                        target: document.getElementById("popup-receive"),
                        icon: "success",
                        title: "สำเร็จ",
                        text: "รับอุปกรณ์เรียบร้อยแล้ว",
                        showConfirmButton: false,
                        timer: 1500,
                      }).then(() => {
                        location.reload();
                        // this.$emit("onToggleReceive", false);
                        // this.$emit("onClosedRecieve", false);
                      });
                    }
                  });
              },
            });
          } else {
            // form have errors
            Swal.fire({
              target: document.getElementById("popup-receive"),
              icon: "warning",
              title: "เกิดข้อผิดพลาด",
              text: "กรุณากรอกข้อมูลให้ถูกต้อง",
              showConfirmButton: false,
            });
          }
        });
      }
    },
    addOtherTool() {
      this.otherTools.push({
        name: null,
        amount: 1,
        serialNumber: null,
        type: 4,
      });
    },
    deleteOtherTool(index) {
      this.otherTools.splice(index, 1);
      // console.log("otherTools ", index, this.otherTools);
    },
    onChangeFiles(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.documentFiles = [];
      this.documentFilesURL = [];
      
      if (files.length > 5) {
        Swal.fire({
          target: document.getElementById("popup-receive"),
          icon: "warning",
          title: "ไฟล์มีจำนวนเกินที่กำหนด",
          text: "กรุณาอัปโหลดไฟล์ไม่เกิน 5 ไฟล์",
          showConfirmButton: false,
          timer: 1500,
        });
      }else{
        for (const item of e.target.files) {
          this.documentFiles.push(item);
          const url = URL.createObjectURL(item);
          this.documentFilesURL.push(url);
        }
      }
    },
    remove(index) {
      this.documentFiles.splice(index, 1);
      this.documentFilesURL.splice(index, 1);
    },
  },
};
</script>

<style lang="css" scoped>
span {
  font-size: 12px;
}
.box {
  padding: 10px 10px 10px 10px;
  width: 400px;
  height: 250px;
  border-style: dotted;
  border-color: #0984e3;
}
.img-show {
  max-width: 370px;
  height: 225px;
}
</style>
